/** Single source of truth for NX itinerary flow detection (post–create-itin, from `itineraryId`). */
export const NX_ITINERARY_ID_PREFIXES = ['NX', 'NIX'] as const

export const isNxItineraryId = (itineraryId: string | undefined | null): boolean => {
    if (!itineraryId) return false
    return NX_ITINERARY_ID_PREFIXES.some(prefix => itineraryId.startsWith(prefix))
}
